import { Component, OnInit, inject } from '@angular/core';
import {HeaderTextService} from '../../../services/header-text.service';
import {ActivatedRoute} from '@angular/router';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import {Destroyed} from '../../shared/directives/destroyed.directive';
import {HomeFileManagerComponent} from '../home-file-manager/home-file-manager.component';

@Component({
    standalone: true,
    selector: 'app-file-manager-tabs',
    templateUrl: './file-manager-tabs.component.html',
    styleUrls: ['./file-manager-tabs.component.scss'],
    imports: [MatTabsModule, HomeFileManagerComponent]
})
export class FileManagerTabsComponent extends Destroyed implements OnInit {
  private readonly headerTextService = inject(HeaderTextService);
  private readonly route = inject(ActivatedRoute);

  title = 'Documents';
  defaultIndex = 0;
  selectedTab;

  tabLoadTimes: Date[] = [];

  ngOnInit() {
    this.headerTextService.setTitle(this.title);
    this.route.params.pipe(this.untilDestroyed()).subscribe((param) => {
      if (param.id && param.id > 0) {
        this.defaultIndex = param.id - 1;
        this.selectedTab = param.id;
      }
    });
  }

  tabChanged($event: MatTabChangeEvent) {
    this.selectedTab = $event.index + 1;
  }
}
